"use client";

// import { useHeaderTheme } from '@/components/providers/HeaderTheme'
import { ExtendedUser } from "@/auth";
import { ProjectWithSlideshow } from "@/components/projects-components-sharedwithstaticsite/types";
import ProjectDetail from "@/components/projects/ProjectDetail";
import React from "react";

// import TubiGridComponent from '@/_test/test/TubiGridComponent'

const PageClient: React.FC<{
    project: ProjectWithSlideshow;
    otherProjects: {
        id: string;
        title: string;
        featuredScreenshotIndex: number;
        //    image: string;
    }[];
    content: string;

    user: ExtendedUser | null;
}> = (params) => {
    const { user, content, project, otherProjects } = params;

    return (
        <>
            <ProjectDetail project={project} content={content} otherProjects={otherProjects} />
        </>
    );
};

export default PageClient;
